import React, { useContext } from 'react';
import { get } from 'lodash';
import LocationCityIcon from '@material-ui/icons/LocationCity';
import {
  useEventCallback,
  NavigationContext,
  DashboardCardAction,
  DashboardCardProps,
} from '@eas/common-web';
import { EvidenceUrl } from '../../../enums';
import { CustomCardBase } from './custom-card-base';

export function CardIRZ({ report, definitionId }: DashboardCardProps) {
  const { navigate } = useContext(NavigationContext);

  const count = get(report, 'data[0].count');
  const requestCount = get(report, 'data[1].count');

  const navigateMain = useEventCallback(() => {
    navigate(EvidenceUrl.IRZ_FACILITIES);
  });

  const navigateRequests = useEventCallback(() => {
    navigate(EvidenceUrl.IRZ_FACILITY_REQUESTS);
  });

  const navigateNewRegistration = useEventCallback(() => {
    navigate(EvidenceUrl.IRZ_FACILITY_REQUEST_NEW);
  });

  return (
    <CustomCardBase
      title="Registr provozoven IRZ"
      definitionId={definitionId}
      value={count}
      icon={<LocationCityIcon />}
      navigate={navigateMain}
    >
      <DashboardCardAction
        navigate={navigateRequests}
        title="Nevyřešené žádosti:"
        value={requestCount}
      />
      <DashboardCardAction
        navigate={navigateNewRegistration}
        title="Nová registrace"
      />
    </CustomCardBase>
  );
}
